import { render, staticRenderFns } from "./rejectToA.vue?vue&type=template&id=50d64069&scoped=true"
import script from "./rejectToA.vue?vue&type=script&lang=js"
export * from "./rejectToA.vue?vue&type=script&lang=js"
import style0 from "./rejectToA.vue?vue&type=style&index=0&id=50d64069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d64069",
  null
  
)

export default component.exports